import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "pa-4 d-flex align-center" }
const _hoisted_2 = {
  key: 2,
  class: "text-caption px-4 text-grey py-2"
}
const _hoisted_3 = { class: "pa-2" }

import { ref, computed } from "vue";

import { useRoute } from "vue-router";
const railWidth = 70;


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar2',
  props: {
    drawer: { type: Boolean },
    isMobile: { type: Boolean },
    theme: {},
    userProfile: {}
  },
  emits: ["update:drawer", "logout"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const route = useRoute();
const emit = __emit;

const isHovered = ref(false);

const customerMenu = ref([
  { title: "Inicio", value: "/", icon: "mdi-view-dashboard" },
  { title: "Mis equipos", value: "/devices", icon: "mdi-broadcast" },
  { title: "Reportes", value: "/reports", icon: "mdi-poll" },
]);

const managerMenu = ref([
    { title: "Inicio", value: "/", icon: "mdi-view-dashboard" },    
  { title: "Equipos", value: "/manager-devices", icon: "mdi-broadcast" },
  { title: "Mediciones", value: "/device-samples", icon: "mdi-ruler" },
    { title: "Compañias", value: "/companies", icon: "mdi-domain" },
  { title: "Clientes", value: "/customers", icon: "mdi-account-group" },
  { title: "Colaboradores", value: "/teams", icon: "mdi-account-hard-hat" },
  // { title: 'Ajutes', value: '/settings', icon: 'mdi-toggle-switch-outline' },
  { title: "Estado", value: "/status", icon: "mdi-list-status" },
]);

const onMouseEnter = () => {
  if (!props.isMobile) {
    isHovered.value = true;
  }
};

const onMouseLeave = () => {
  isHovered.value = false;
};

const expandedDrawer = computed(() => {
  return props.drawer || isHovered.value;
});
const drawerColor = computed(() => {
  return props.theme === "myCustomDarkTheme" ? "#1e1e2d" : "#f5f5f5";
});

const railEnabled = computed(() => {
  return !props.isMobile && !expandedDrawer.value;
});

const currentMenu = computed(() => {
  const role = props.userProfile?.role;
  return role === "admin" ? managerMenu.value : customerMenu.value;
});

const showAdminSection = computed(() => {
  return props.userProfile?.role === "admin";
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    class: "sidebar bg-background",
    "model-value": true,
    rail: railEnabled.value,
    "rail-width": railWidth,
    width: 260,
    permanent: true,
    temporary: props.isMobile,
    location: props.isMobile ? 'bottom' : 'left',
    onMouseenter: onMouseEnter,
    onMouseleave: onMouseLeave
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_avatar, {
          size: "44",
          class: "d-flex align-center justify-center text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              class: "py-2",
              src: "/isowipi.svg"
            })
          ]),
          _: 1
        }),
        (expandedDrawer.value)
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 0,
              height: "50",
              src: "/textwipi.svg"
            }))
          : _createCommentVNode("", true)
      ]),
      (!showAdminSection.value)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 0,
            class: "pa-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentMenu.value, (item, i) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: i,
                  value: item.value,
                  title: expandedDrawer.value ? item.title : '',
                  "prepend-icon": item.icon,
                  to: item.value,
                  active: _unref(route).path === item.value,
                  class: _normalizeClass({ 'rounded-lg': true, 'mb-1': true }),
                  link: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (props.isMobile ? emit('update:drawer', false) : null))
                }, null, 8, ["value", "title", "prepend-icon", "to", "active"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (showAdminSection.value)
        ? (_openBlock(), _createBlock(_component_v_divider, {
            key: 1,
            class: "mx-4 my-2"
          }))
        : _createCommentVNode("", true),
      (expandedDrawer.value && showAdminSection.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Administración "))
        : _createCommentVNode("", true),
      (showAdminSection.value)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 3,
            class: "pa-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerMenu.value, (item, i) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: i,
                  value: item.value,
                  title: expandedDrawer.value ? item.title : '',
                  "prepend-icon": item.icon,
                  active: _unref(route).path === item.value,
                  class: _normalizeClass({ 'rounded-lg': true, 'mb-1': true }),
                  to: item.value,
                  link: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (props.isMobile ? emit('update:drawer', false) : null))
                }, null, 8, ["value", "title", "prepend-icon", "active", "to"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (expandedDrawer.value)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_btn, {
                block: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('logout'))),
                variant: "text",
                color: "error"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Cerrar sesión")
                ])),
                _: 1
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["rail", "temporary", "location"]))
}
}

})